( function( $ ) {
    $(document).ready( function() {
        
        // Clean up any existing event handlers to prevent duplicates
        $(document).off('click.fundingCard');
        $(document).off('keydown.fundingCard');
        
        // Use event delegation with namespace
        $(document).on('click.fundingCard', '.funding-card', function(e) {
            e.preventDefault();
            
            // Remove active class from all other funding cards
            $('.funding-card').not(this).removeClass('active');
            
            // Toggle active class on clicked card
            $(this).toggleClass('active');
        });
        
        // Close active card when clicking outside (also namespaced)
        $(document).on('click.fundingCard', function(e) {
            if (!$(e.target).closest('.funding-card').length) {
                $('.funding-card').removeClass('active');
            }
        });
        
        // Prevent closing when clicking inside the active card
        $(document).on('click.fundingCard', '.funding-card.active', function(e) {
            e.stopPropagation();
        });
        
        // Keyboard support with namespace
        $(document).on('keydown.fundingCard', function(e) {
            if (e.key === 'Escape') {
                $('.funding-card').removeClass('active');
            }
        });

    } );
} )( jQuery );